<template>
    <div>
        <div class="mt-4 mb-2 text-left">
            <h3 class="text-lg mb-1">Bienvenido de nuevo</h3>
            <p class="text-md text-muted">Registrate para acceder a su casillero de compras internacionales.</p>
        </div>
        <form @submit.prevent="REGISTER()">
            <div class="form-group mb-2">
                <small class="input-title">Tipo de cuenta</small>
                <v-select v-model="data.account_type" :items="accounts.filter((e) => e.value != 0)" hide-details
                    @change="CHANGE"
                    class="form-control"
                    :class="errors.account_type ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.account_type"
                    :key="index">{{ error }}</small>
            </div>
            <div class="form-group mb-2" v-if="data.account_type == 2">
                <small class="input-title">Nombre de la Empresa</small>
                <input type="text" class="form-control" v-model="data.company"
                    :class="errors.company ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.company"
                    :key="index">{{ error }}</small>
            </div>
            <div class="form-group mb-2" v-if="data.account_type != 2">
                <small class="input-title">Nombre</small>
                <input type="text" class="form-control"
                    v-model="data.first_name" :class="errors.first_name ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.first_name"
                    :key="index">{{ error }}</small>
            </div>
            <div class="form-group mb-2" v-if="data.account_type != 2">
                <small class="input-title">Apellido</small>
                <input type="text" class="form-control" v-model="data.last_name"
                    :class="errors.last_name ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.last_name"
                    :key="index">{{ error }}</small>
            </div>
            <div class="form-group mb-2">
                <small class="input-title">Tipo de Identificación</small>
                <v-select v-model="data.identification_type"
                    :items="identifications.filter((e) => data.account_type == 2 ? e.value == 2 : e.value != 2)"
                    hide-details
                    class="form-control"
                    :class="errors.identification_type ? 'is-invalid' : ''">
                </v-select>
                <small class="invalid-feedback" v-for="(error, index) in errors.identification_type" :key="index">{{ error }}</small>
            </div>
            <div class="form-group mb-2">
                <small class="input-title">{{ data.account_type == 2 ? 'Cédula Jurídica' : 'Identificación' }}</small>
                <input type="text" class="form-control" v-mask="format" v-model="data.identification" :class="errors.identification ? 'is-invalid' : ''">
                <small class="invalid-feedback" v-for="(error, index) in errors.identification" :key="index">{{ error }}</small>
                <small v-if="data.account_type == 2">Ejemplo: Si es 3-101-123456 se debe digitar 3101123456</small>
            </div>
            <div class="form-group mb-2">
                <small class="input-title">Correo electrónico</small>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="bi bi-envelope"></i>
                        </span>
                    </div>
                    <input type="email" class="form-control" v-model="data.email"
                        :class="errors.email ? 'is-invalid' : ''">
                    <small class="invalid-feedback" v-for="(error, index) in errors.email"
                        :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="form-group mb-3">
                <small class="input-title">Contraseña</small>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="bi bi-lock"></i>
                        </span>
                    </div>
                    <v-text-field v-model="data.password"
                        :append-icon="type ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="type ? 'text' : 'password'" class="form-control" hide-details
                        @click:append="type = !type"
                        :class="errors.password ? 'is-invalid' : ''">
                    </v-text-field>
                    <small class="invalid-feedback" v-for="(error, index) in errors.password"
                        :key="index">{{ error }}</small>
                </div>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary btn-x w-100">
                    <div class="spinner-border spinner-border-sm" role="status"
                        v-if="count == 1">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span v-else>Afiliarme</span>
                </button>
            </div>
        </form>
        <div class="mt-4 d-flex justify-content-start gap-2">
            <div class="mb-3">¿Ya tienes una cuenta?<router-link
                    :to="{ name: 'Login' }"> Iniciar sesión</router-link></div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            type: false,
            data: {
                account_type: 1,
                identification_type: 1,
                email: '',
                password: ''
            },
            errors: {},
            count: 0,
            identifications: [
                { value: 1, text: 'Cédula Nacional' },
                { value: 2, text: 'Cédula Juridica' },
                { value: 3, text: 'Cédula de Residencia (DIMEX)' },
                { value: 4, text: 'Pasaporte' },
            ]
        }
    },
    computed: {
        ...mapGetters([
            'accounts',
        ]),
        format: function(){
            let format = ''
            if(this.data.identification_type == 1){
                format = '0#-####-####'
            } else if(this.data.identification_type == 2){
                format = '3-###-######'
            } else if(this.data.identification_type == 3){
                format = '1############'
            } else {
                format = '9#################'
            }
            return format
        }
    },
    methods: {
        CHANGE: function () {
            let data = this.identifications.filter((e) => this.data.account_type == 2 ? e.value == 2 : e.value != 2)
            this.data.identification_type = data.findIndex((e) => e.value == this.data.identification_type) != -1 ? this.data.identification_type : data[0].value
        },
        REGISTER: function () {
            let vue = this
            vue.count++
            vue.errors = {}
            if (vue.count == 1) {
                if(vue.data.account_type == 2){
                    vue.data.identification_type = 2
                }
                axios({ url: '/register', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'Thanks', params: { slug: resp.data.slug } })
                    })
                    .catch((err) => {
                        if (err.response.status !== 422) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
};
</script>
  